import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';

interface PreviewSignal {
  id: string;
  text: string;
  renderedIconUrl: string;
}

@Component({
  selector: 'trust-signals-component-preview',
  templateUrl: './trust-signals-component-preview.component.html',
  styleUrls: ['./trust-signals-component-preview.component.scss'],
  standalone: false,
})
export class TrustSignalsComponentPreviewComponent implements OnChanges, OnDestroy {
  @Input() options: ShopPlugin.ProductPagePromise.TrustSignalsOptions;

  visibleSignals: PreviewSignal[] = [];

  private blobUrls: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.refreshSignals();
    }
  }

  ngOnDestroy(): void {
    this.revokeBlobUrls();
  }

  private refreshSignals(): void {
    this.revokeBlobUrls();
    const signals = this.options?.signals ?? [];
    this.visibleSignals = signals
      .filter((signal) => signal.text && signal.text.trim().length > 0)
      .map((signal) => {
        const rawIconUrl = signal.iconUrl as unknown;
        let renderedIconUrl = '';
        if (rawIconUrl instanceof File) {
          renderedIconUrl = URL.createObjectURL(rawIconUrl);
          this.blobUrls.push(renderedIconUrl);
        } else if (typeof rawIconUrl === 'string' && rawIconUrl) {
          renderedIconUrl = rawIconUrl;
        }
        return {
          id: signal.id,
          text: signal.text,
          renderedIconUrl,
        };
      });
  }

  private revokeBlobUrls(): void {
    for (const url of this.blobUrls) {
      URL.revokeObjectURL(url);
    }
    this.blobUrls = [];
  }
}
